import { convertPlatformCode } from '@buggy/shared'
import { logger } from '@sentry/utils'
import { capitalize } from 'lodash-es'
import { COUNTRY_I18N_MAP } from '@/constants/country-code'
import routes from '@/hooks/use-authorization/routes'
import { useIntl } from '@/i18n/hooks/use-intl'
import { BillboardMultiDimensionParams } from '@/types/schema/billboard/multi-dimension'
import { countryCodeSchema } from '@/types/schema/country-code-schema'
import {
  rankingPlatformSchema,
  RankingPlatformType,
} from '@/types/schema/k6/analyze-api'
import { platformCodeSchema } from '@/types/schema/platform/platform-code-schema'
import { platformShortcodeSchema } from '@/types/schema/platform/platform-shortcode-schema'

const useBillboardMultiDimensionParams = (): BillboardMultiDimensionParams & {
  platformTitle: string
  countryTitle: string
  rankingPlatform: RankingPlatformType
} => {
  const { formatMessage } = useIntl()
  const params = routes.billboardCustomizedTagList.useParams()
  const defaultCountry = countryCodeSchema.enum.tw
  const defaultPlatformShortCode = platformShortcodeSchema.enum.ig
  const defaultPlatformTitle = capitalize(platformCodeSchema.enum.instagram)

  if (!params.success) {
    logger.error(params.error)

    return {
      platform: platformCodeSchema.enum.instagram,
      country: countryCodeSchema.enum.tw,
      platformTitle: defaultPlatformTitle,
      countryTitle: formatMessage({ id: COUNTRY_I18N_MAP[defaultCountry] }),
      rankingPlatform: defaultPlatformShortCode,
    }
  }

  const rankingPlatformParseResult = rankingPlatformSchema.safeParse(
    convertPlatformCode(params.data.platform)?.shortcode,
  )

  return {
    ...params.data,
    platformTitle:
      convertPlatformCode(params.data.platform)?.title ?? defaultPlatformTitle,
    countryTitle: params.data.country
      ? formatMessage({ id: COUNTRY_I18N_MAP[params.data.country] })
      : formatMessage({ id: COUNTRY_I18N_MAP[defaultCountry] }),
    rankingPlatform: rankingPlatformParseResult.success
      ? rankingPlatformParseResult.data
      : defaultPlatformShortCode,
  }
}

export default useBillboardMultiDimensionParams
